export const formatCurrency = (amount, currency = "USD") => {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency,
  }).format(amount);
};

export const readNumber = (number) => {
  const units = ["", "một", "hai", "ba", "bốn", "năm", "sáu", "bảy", "tám", "chín"];
  const tens = ["", "mười", "hai mươi", "ba mươi", "bốn mươi", "năm mươi", "sáu mươi", "bảy mươi", "tám mươi", "chín mươi"];
  const scales = ["", "nghìn", "triệu", "tỷ"];

  if (number === 0) return "không đồng";

  let str = "";
  let numStr = number.toString();
  let chunks = [];

  // Cắt số thành từng nhóm 3 chữ số
  while (numStr.length > 0) {
    chunks.unshift(numStr.slice(-3));
    numStr = numStr.slice(0, -3);
  }

  for (let i = 0; i < chunks.length; i++) {
    let chunk = parseInt(chunks[i], 10);
    if (chunk === 0) continue;

    let hundreds = Math.floor(chunk / 100);
    let remainder = chunk % 100;
    let tensDigit = Math.floor(remainder / 10);
    let onesDigit = remainder % 10;

    let chunkStr = "";

    if (hundreds) chunkStr += units[hundreds] + " trăm ";
    // if (tensDigit === 0 && onesDigit !== 0) chunkStr += "lẻ ";
    if (tensDigit === 1) chunkStr += "mười ";
    else if (tensDigit > 1) chunkStr += tens[tensDigit] + " ";

    if (onesDigit === 5 && tensDigit > 0) chunkStr += "lăm ";
    else if (onesDigit > 0) chunkStr += units[onesDigit] + " ";

    str += chunkStr.trim() + " " + scales[chunks.length - 1 - i] + " ";
  }

  return str.trim() + " đồng";
}